<div class="page">
  <div class="container">
    <h1>Data Deletion Instructions — {{ appName }}</h1>

    <p>
      {{ appName }} (“we”, “us”, “our”) respects your privacy and provides a clear way to request deletion of your account and associated data.
    </p>

    <p>
      If you logged in using Facebook Login and would like your data deleted from {{ appName }}, follow the instructions below.
    </p>

    <hr />

    <h2>Option 1 (Recommended): Request deletion by email</h2>
    <p>
      Send an email to:
      <strong>{{ contactEmail }}</strong>
    </p>

    <p class="note">
      <strong>Subject line:</strong> Data Deletion Request — {{ appName }}
    </p>

    <p>Please include:</p>
    <ul>
      <li>Your name</li>
      <li>The email address associated with your {{ appName }} account (or your Facebook email)</li>
      <li>Your Facebook User ID (optional but helpful)</li>
    </ul>

    <h2>What We Delete</h2>
    <p>When your request is confirmed, we will delete:</p>
    <ul>
      <li>Your account profile (name, email, user ID)</li>
      <li>Stored authentication identifiers (Facebook ID)</li>
      <li>Associated user records stored in our system</li>
    </ul>

    <p>
      We may retain minimal information if required by law, security, fraud prevention, or compliance purposes.
    </p>

    <h2>Processing Time</h2>
    <p>
      We will process deletion requests within:
      <strong>{{ estimatedProcessingTime }}</strong>
    </p>

    <h2>Confirmation</h2>
    <p>
      Once deletion is complete, you will receive confirmation via email.
    </p>

    <hr />

    <h2>Option 2 (Optional): Remove {{ appName }} from Facebook</h2>
    <p>
      You can remove the app from Facebook at any time:
    </p>

    <p class="note">
      Facebook Settings → Apps and Websites → Find "{{ appName }}" → Remove
    </p>

    <p>
      This prevents future logins, but if you want your stored data deleted, you must still email us using Option 1.
    </p>

    <h2>Contact</h2>
    <div class="contact-box">
      <p><strong>Email:</strong> {{ contactEmail }}</p>
      <p><strong>Website:</strong> <a [href]="websiteUrl" target="_blank" rel="noopener noreferrer">{{ websiteUrl }}</a></p>
    </div>
  </div>
</div>
